import UserState from "state/UserState";
import { useCanEditFolderSubscription } from "__gen__/appService";

export default ({ folderId }: { folderId: string }) => {
  const { user } = UserState.useContainer();
  const { data } = useCanEditFolderSubscription({
    folderId,
    userId: user?.id || "",
  });

  return (data?.editableFolders.length || []) > 0;
};
